import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import './style/swiper-bundle.min.css';

import Head from './components/Head';
import Home from './components/Home';
import Information from './components/Information';
import Select from './components/Select';
import Questions from './components/Questions';

function App() {
  return (
    <div className="App">
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<Head />}>
					<Route index element={<Home />}/>
					<Route path='/information' element={<Information />}/>
					<Route path='/select' element={<Select />}/>
					<Route path='/questions' element={<Questions />}/>
				</Route>
			</Routes>
		</BrowserRouter>
    </div>
  );
}

export default App;
